import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'gatsby';
import DriverLogo from '/src/images/driver-logo.svg';

const PageFooter = () => {
	const { t } = useTranslation();

	return (
		<footer id="driver-footer">
			<div>
				<div>
					<img
						src={DriverLogo}
						alt={t('v2.footer.driver-technologies')}
					/>
				</div>

				{/*<div>
					<h6>{t('v2.footer.platform')}</h6>
					<ul>
						<li>
							<Link to="/#driver-app">{t('v2.footer.driver-app')}</Link>
						</li>
						<li>
							<Link to="/#driver-cloud-sharing">{t('v2.footer.drivercloud')}</Link>
						</li>
						<li>
							<Link to="#">{t('v2.footer.driverpremium')}</Link>
						</li>
					</ul>
				</div>*/}

				<div>
					<h6>{t('v2.footer.business')}</h6>
					<ul>
						<li>
							<Link to="/pricing">{t('v2.footer.pricing')}</Link>
						</li>
					</ul>
				</div>

				<div>
					<h6>{t('v2.footer.support')}</h6>
					<ul>
						<li>
							<Link to="/privacy-policy">{t('v2.footer.privacy-policy')}</Link>
						</li>
						<li>
							<Link to="/privacy-policy/#terms-and-conditions">{t('v2.footer.terms-and-conditions')}</Link>
						</li>
						<li>
							<Link to="/security">{t('v2.footer.security-reports')}</Link>
						</li>
						<li>
							<Link to="/consumer-report">{t('v2.footer.consumer-rights-under-fcra')}</Link>
						</li>
						<li>
							<Link to="/data-subject-access-requests">{t('v2.footer.data-subject-access-requests')}</Link>
						</li>
						<li>
							<a href="https://trydriver.zendesk.com/hc/en-us">{t('v2.footer.help-center')}</a>
						</li>
					</ul>
				</div>

				<div>
					<h6>{t('v2.footer.company')}</h6>
					<ul>
						<li>
							<Link to="/#about-us">{t('v2.footer.about-us')}</Link>
						</li>
						<li>
							<Link to="/careers">{t('v2.footer.careers')}</Link>
							<strong className="green">{t('v2.footer.we-are-hiring')}</strong>
						</li>
						<li>
							<a href="mailto:info@drivertechnologies.com">{t('v2.footer.contact-us')}</a>
						</li>
					</ul>
				</div>
			</div>
		</footer>
	);
};

export default PageFooter;
